export const screenCopyZh = {
  app: {
    checkingSignInStatus: "正在檢查登入狀態…",
  },
  assignmentRecords: {
    backToCategories: "← 返回分類",
    closeNewTask: "收起新增",
    newTaskRecord: "＋ 新增事項記錄",
    recordCategories: "事項記錄分類",
    enterATaskNameAndAValid: "請填寫事項名稱及有效滿分。",
    theMaximumCannotBeLowerThanSaved: "滿分不可低於已保存的學生分數，請先修改分數。",
    couldNotSaveTheTaskTryAgain: "未能保存事項，請重試。",
    eGWorksheetUnitTest: "例如：工作紙三／單元一測驗",
    dueTestDate: "繳交／測驗日期",
    maximumScoreOptional: "滿分（選填）",
    eG: "例如：100",
    taskNotes: "事項備註",
    searchTasks: "搜尋事項",
    searchTasksDatesOrNotes: "搜尋事項、日期或備註",
    showing: "顯示",
    records: "份記錄",
    taskDetails: "事項內容",
    open: "開啟{{title}}",
    outOf: " · 滿分 {{maxScore}}",
    no: "{{number}} 號 {{name}}",
    noRecordsMatchYourSearch: "找不到符合搜尋的記錄。",
    youHaveUnsavedChangesReturnToThe: "尚有未保存修改，確定返回目錄？",
    saveFailedYourChangesRemainOnScreen: "保存失敗，你的修改仍保留在畫面上，請重試。",
    backToRecordDirectory: "← 返回事項目錄",
    notSavedYet: "尚未保存",
    score: "分數",
    noActiveStudentsInThisClassImport: "此班尚未有啟用學生，請先在後台管理匯入名單。",
  },
  betaFeedback: {
    submissionFailedYourFeedbackIsRetained: "未能提交。回饋內容仍保留。",
    trialFeedback: "提供試用回饋",
    closeFeedback: "關閉回饋",
    feedbackIsOptionalAndSentWithYour:
      "回饋完全自願，會以目前已登入帳戶提交。只傳送類別、內容及你選擇填寫的電郵，不附班級、學生資料或操作紀錄。請勿在內容填寫學生姓名或其他個人資料。",
    feedbackReceivedThankYouForHelpingImprove: "回饋已收到，多謝你協助改善試用體驗。",
    writeMoreFeedback: "再寫一份回饋",
    nothingIsSentUntilYouConfirm: "確認後才會提交",
    feedbackToSubmit: "將提交的回饋",
    content: "內容",
    followUpEmail: "跟進電郵",
    noEmailProvided: "不提供電郵",
    backToEdit: "返回修改",
    submitting: "正在提交…",
    confirmAndSubmitFeedback: "確認提交回饋",
    checkTheFeedbackContent: "請檢查回饋內容。",
    feedbackCategory: "回饋類別",
    feedbackContent: "回饋內容",
    whichFeatureHasAProblemOrWhat: "哪個功能有問題，或你希望改善甚麼？",
    characters: "/ 2000 字",
    iWouldLikeToProvideAnEmail: "我願意留下電郵，方便跟進",
    previewFeedback: "預覽回饋",
  },
  calendarImportDialog: {
    publicHoliday: "公眾假期",
    schoolHoliday: "學校假期",
    specialSchoolDay: "特別上課日",
    specialDate: "特別日子",
    examAssessment: "考試／評估",
    studentActivity: "學生活動",
    administrativeReminderDeadline: "行政提醒／限期",
    classTest: "班級測驗",
    enterAValidStartDate: "請填寫有效的開始日期",
    invalidEndDateFormat: "結束日期格式不正確",
    endDateIsBeforeStartDate: "結束日期早於開始日期",
    enterAnEventName: "請填寫事項名稱",
    anEventWithTheSameDateAnd: "日曆已有相同日期及名稱的事項",
    noCalendarEventsFoundToReview: "沒有找到可供核對的日曆事項。",
    couldNotReadTheSchoolCalendarFile: "未能讀取校曆檔案。",
    selectAtLeastOneValidSchoolCalendar: "請至少選擇一項有效的校曆事項。 ",
    itemsStillNeedCorrection: "仍有 {{length}} 項資料需要修正。",
    couldNotImportSchoolCalendarEvents: "未能匯入校曆事項。",
    importSchoolCalendar: "匯入學校校曆",
    schoolYearStartingYearOptional: "學年開始年份（可選）",
    eG: "例如 2026",
    chooseCalendarFile: "選擇校曆檔案",
    excelXlsxCSVICSOrPDF: "Excel (.xlsx)、CSV、ICS 或 PDF",
    analyseAgain: "重新辨識",
    chooseAnotherFile: "更換檔案",
    processingTheSchoolCalendarPleaseWait: "正在處理校曆，請稍候…",
    pleaseNote: "請留意",
    recognised: "辨認到",
    items: "項",
    selected: "項已選擇 ·",
    availableToImport: "項可匯入",
    selectAllImportableItems: "選擇全部可匯入項目",
    needReviewOrCorrection: "項需要核對或修正",
    item: "第",
    label: "項：",
    schoolCalendarEventsToReview: "待核對的校曆事項",
    import: "匯入",
    event: "事項",
    sourceAndStatus: "來源及狀態",
    importItem: "匯入第 {{value}} 項 {{title}}",
    start: "開始",
    end: "結束",
    notesOptional: "備註（可選）",
    highConfidence: "高信心",
    quickReviewNeeded: "需快速核對",
    correctionNeeded: "需要修正",
    viewSourceText: "查看來源文字",
  },
  legalAcceptanceGate: {
    couldNotRecordAcceptanceTryAgain: "未能記錄接受資料，請再試一次。",
    setUpTheCollectionNoticeBeforeUsing: "使用真實學生資料前，先設定收集資料告示",
    theseDetailsAppearBeforeStudentsJoinQuizzes:
      "以下資料會在學生加入小測前顯示，讓學生知道由誰收集資料，以及向誰提出查閱或改正要求。",
    theOperatorSLegalContactDetailsAre: "營運者法律聯絡資料尚未完成設定，現階段不可接受條款或輸入真實學生資料。",
    schoolDataUserName: "學校／資料使用者名稱",
    personOrTitleHandlingAccessAndCorrection: "處理查閱及改正要求的人員姓名或職銜",
    eGDataProtectionOfficer: "例如：資料保障主任",
    contactEmail: "聯絡電郵",
    contactAddress: "聯絡地址",
    iHaveReadAndAccept: "我已閱讀並接受",
    and: "及",
    iConfirmSchoolAuthorisationToProcessAnd:
      "我確認已獲學校授權處理及上載相關學生資料，並會在上載名單前向學生／家長提供適用的收集個人資料聲明。",
    recording: "正在記錄…",
    saveNoticeAndConfirm: "儲存告示並確認",
    schoolContactsAcceptanceDateAndTermsVersions:
      "學校聯絡資料、接受日期及條款版本會保存在帳戶內，供每次小測告知及合規紀錄使用。",
  },
  localDataPanel: {
    encryptedBackupDownloadedSaveItToYour: "加密備份已下載。請把檔案另存到你選用的雲端硬碟，並分開保管密碼。",
    backupFailed: "備份失敗。",
    restoringReplacesAllLocalClassroomDataIn:
      "還原會以備份檔取代目前這個瀏覽器的全部本地課堂資料。請先下載目前資料的備份。確定繼續？",
    backupRestoredCheckThatYourClassesAnd: "備份已還原。請檢查班別與紀錄是否完整。",
    restoreFailedExistingDataIsUnchanged: "還原失敗；現有資料沒有被更改。",
    localData: "本地資料",
    dataInThisBrowser: "這個瀏覽器的資料",
    available: "可用",
    checkingUnsupported: "檢查中／不支援",
    persistentStorage: "持久儲存",
    granted: "已允許",
    notGranted: "尚未允許",
    siteStorageUsed: "網站已用空間",
    processing: "處理中…",
    readingDataAndCreatingAConsistentSnapshot: "正在讀取資料並建立一致快照…",
    encryptingBackup: "正在加密備份…",
    restoreFromEncryptedFile: "從加密檔還原",
    chooseBackupFile: "選擇備份檔",
  },
  pwaUpdateNotice: {
    localDataIsStillBeingProcessedWait: "本機資料仍在處理，請等候保存完成後再更新。",
    saveClassroomRecordsFirstUpdatingReloadsThe:
      "請先保存課堂紀錄。更新會重新載入頁面，未保存的輸入會消失。已完成保存並準備更新？",
    theUpdateIsNotReadyTryAgain: "更新尚未準備好，請稍後再試。",
    theNewVersionHasDownloadedInThe: "新版已在背景下載。請先保存工作，再按更新；已保存的本機資料會保留。",
    updating: "正在更新…",
    updateAfterSaving: "保存完成後更新",
  },
  recordImportPanel: {
    couldNotAnalyseTheWorksheet: "未能分析工作表。",
    importedRowsInto: "已匯入 {{length}} 行「{{label}}」記錄到 {{name}}",
    couldNotCompleteImportIfSomeData:
      "未能完成匯入：{{value}}。若部分資料已儲存，請重新載入頁面再檢查，系統會辨認已存在的記錄。",
    chooseAClassFirst: "請先選擇班別。",
    recordType: "記錄種類",
    headerRow: "標題所在行",
    row: "第",
    label: "行：",
    reviewColumns: "核對欄位",
    doNotUse: "不使用",
    untitledColumn: "無標題（第 {{value}} 欄）",
    readyToImport: "可匯入",
    alreadyExists: "已存在",
    conflict: "有衝突",
    needsCorrection: "需修正",
    selected: "已選",
    import: "匯入",
    record: "記錄",
    checkResult: "檢查結果",
    importRow: "匯入第 {{rowNumber}} 行",
    importing: "匯入中…",
    confirmImportOfRows: "確認匯入 {{length}} 行",
  },
  teacherConsole: {
    participationOverview: "表現總覽",
    recordEntry: "事項記錄",
    questionBankAndQuizzes: "題庫小測",
    sharedTools: "共用工具",
    administration: "管理",
    leaveLocalTrial: "離開本地試用",
    leavePreview: "離開預覽",
    featureTourCompleteYouCanNowEdit: "功能導覽完成；現在可以自由修改虛擬資料。",
    demoFeatureTourDoesNotCover: "Demo 功能導覽尚未涵蓋：",
    localData: "本地資料",
    preparingYourClassroom: "正在準備你的課堂…",
    checkingPrivacyAndTermsAcceptance: "正在核對私隱及使用條款紀錄…",
    sharedClassNotFoundSelectItAgain: "共用班別不存在，請重新選擇。",
    matchingTaskNotFoundReopenTheRecord: "找不到對應事項，請重新開啟事項目錄。",
    localQuizzesAreNotAvailableYet: "本地小測暫未開放。",
    tools: "工具欄",
    tabs: "{{recordGroupLabel}}分頁",
    skipToClassSelection: "跳到班別選擇",
    startClassSetup: "開始設定課堂",
    whichClassAreYouTeachingToday: "今天教哪一班？",
    featureTour: "功能導覽",
    localPreviewOnly: "只限本機預覽",
    setupGuide: "設定指引",
    gettingStartedGuide: "新手設定指引",
    firstTimeSetup: "首次設定",
    readyToBegin: "可以開始使用了",
    setUpClassesRostersAndSeatingFirst: "先完成班別、名單和座位表",
    setupProgress: "設定進度",
    settingUp: "正在設定",
    createClass: "建立班別",
    addAnotherClass: "新增另一班",
    completeTheDetailsBelow: "填寫下方資料",
    students: "位學生",
    viewRoster: "查看名單",
    viewSeats: "查看座位",
    arrangeSeats: "編排座位",
    open: "進入",
    importSchoolWideCalendar: "匯入全校校曆",
    chooseVisibleTools: "選擇顯示工具",
    backToClassSelection: "返回班別選擇",
    noHomeroomClassCreatedYet: "尚未建立班主任班。",
    noTeachingClassesCreatedYet: "尚未建立任教班別。",
    couldNotCreateTheClass: "未能建立班別。",
    newClassName: "新增班別名稱",
    eGAChinese: "例如：1A 中文",
    classPurpose: "班別用途",
    createNewData: "建立新資料",
    useDataFrom: "使用「",
    label: "」的資料",
    creating: "建立中…",
    addClass: "＋ 新增班別",
    createYourFirstClass: "先建立第一個班別",
    goToClassRoster: "前往班級名單",
    toolVisibilitySettingsSaved: "工具顯示設定已保存",
    couldNotSaveSettings: "設定未能保存。",
    visible: "項顯示",
    showAll: "顯示全部",
    saving: "儲存中…",
    saveSettings: "保存設定",
    show: "顯示{{label}}",
    label_e6d84: "{{value}}年{{value1}}月",
    otherClasses: "其他班別",
    schoolWide: "全校",
    viewCalendar: "{{value}}，{{scope}}，{{value2}}：{{title}}，查看日曆",
    agendaRange: "日程檢視範圍",
    nextTwoWeeks: "未來兩星期",
    fullYear: "看全年",
    eventsInTheNextTwoWeeks: "未來兩星期事項",
    events: "項事項",
    nextTwoWeeksCalendar: "未來兩星期日曆",
    week: "週",
    events_5f353: "{{value}}，{{length}} 項事項",
    month: "月",
    events_9cc64: "項",
    viewCalendar_89ab2: "{{value}}：{{title}}，查看日曆",
    more: "另有",
    allTasksInTheNextTwoWeeks: "未來兩星期全部任務",
    noTasksInTheNextTwoWeeks: "未來兩星期暫無任務",
    fullYearEvents: "全年事項",
    schoolYearOverviewSeptemberToAugust: "學年總覽 · 9月至翌年8月",
    previousSchoolYear: "上一學年",
    nextSchoolYear: "下一學年",
    noEvents: "暫無事項",
    events_9916d: "{{label}}事項",
    noEventsThisMonth: "這個月暫無事項。",
    classStatistics: "課堂統計",
    totalMissingMaterials: "累計欠帶書簿次數",
    missingMaterialsToday: "今天欠帶書簿學生",
    totalResponses: "累計回答次數",
    studentsWhoHaveAnswered: "曾回答學生",
    responsesToday: "今天回答次數",
    noSeatingChartYet: "尚未設定座位表",
    openSeatingChart: "前往座位表",
    teacherView: "教師視角 ·",
    rows: "行 ×",
    columns: "列 ·",
    aisles: "條走廊",
    no: "號",
    recordedTodayTotal: "今日已記錄 · 累計 {{missingMaterials}} 次",
    total: "累計 {{missingMaterials}} 次",
    answers: "次回答",
    randomSelectionAndGroupingTools: "抽人分組工具",
    chooseTool: "選擇工具",
    pickStudents: "抽人",
    quickGroups: "快速分組",
    studentsNoRepeatsThisRound: "位學生 · 本輪不重複",
    createGroups: "產生分組",
    randomStudentPicker: "隨機抽人",
    selecting: "抽選中…",
    selectedThisTime: "本次抽中",
    readyToPick: "準備抽人",
    selectTheButtonToBegin: "按下按鈕開始",
    currentRound: "本輪名單",
    remaining: "尚餘",
    students_49127: "人",
    pickAStudent: "開始抽人",
    roundComplete: "本輪已完成",
    resetRoster: "重設名單",
    startNextRound: "開始下一輪",
    quickBalancedGroups: "快速平均分組",
    group: "第",
    chooseAMethodToCreateGroups: "設定方式後產生分組",
    noTaskDescription: "未填項目內容",
    searchStudents: "搜尋學生",
    enterNameOrClassNumber: "輸入姓名或班號",
    active: "在讀",
    noMatchingStudents: "找不到符合的學生。",
    classOverview: "班級總覽",
    studentRecordCategories: "學生記錄類別",
    attendanceRecords: "出勤記錄",
    classRecordSummary: "班級記錄摘要",
    recordedDays: "已記錄日數",
    absences: "缺席人次",
    attendanceChecks: "次點名",
    lateArrivals: "遲到人次",
    activeStudents: "位啟用學生",
    missingSubmissions: "欠交人次",
    records: "項記錄",
    studentsWithMoreRecords: "記錄較多學生",
    late: "遲到",
    noStudentRecordsToSummariseYet: "目前沒有需要彙整的學生記錄。",
    missingWorkBySubject: "欠交科目分布",
    missingSubmissions_305a6: "{{subject}}欠交 {{count}} 人次",
    noMissingWorkRecordsYet: "尚未有欠交記錄。",
    recentRecords: "最近記錄",
    openAttendance: "前往點名",
    openMissingHomework: "前往欠交記錄",
    noAttendanceOrMissingWorkRecordsYet: "尚未記錄出勤或欠交事項。",
    absentDates: "缺席日期",
    openAttendance_8f396: "前往點名 →",
    noAbsencesRecorded: "沒有缺席記錄",
    missingSubmissions_28ccc: "欠交次數",
    subjectsInvolved: "涉及科目",
    latestMissingWork: "最近欠交",
    missingTasks: "欠交項目",
    openMissingHomework_476e3: "前往欠交記錄 →",
    bySubject: "按科目",
    noMissingWorkRecordsForThisStudent: "目前沒有這位學生的欠交紀錄。",
    studentNotFound: "找不到學生",
    noStudentRosterYet: "尚未有學生名單",
    classAttendance: "全班點名",
    attendanceDate: "點名日期",
    attendanceStatistics: "點名統計",
    classTotal: "全班",
    attendanceBySeat: "按座位點名",
    label_07242: "，{{genderLabel}}生",
    unseated: "未編座位 ·",
    enterAUniqueSubjectNameOfTo: "請輸入 1 至 40 字、尚未存在的科目名稱。",
    addedSubject: "已加入科目「{{name}}」",
    couldNotAddTheSubject: "未能加入科目。",
    delete: "確定刪除「{{value}}{{value1}}」？",
    missingWorkRecordDeleted: "欠交記錄已刪除",
    couldNotDeleteTheMissingWorkRecord: "未能刪除欠交記錄。",
    no_ed3bb: "{{number}} 號 {{name}}：{{value}}",
    missing: "✓ 欠交",
    submitted: "已交",
    selected: "已選",
    students_74c77: "位",
    editMissingTask: "修改欠交項目",
    newMissingTask: "新增欠交項目",
    subject: "科目",
    chooseSubject: "請選科目",
    notApplicable: "不適用",
    customSubject: "自訂科目",
    enterAnotherSubject: "輸入其他科目",
    addSubject: "加入科目",
    recordAnotherDate: "補記其他日期",
    backToToday: "返回今天",
    missingWorkType: "欠交種類",
    taskDescription: "項目內容",
    eGWorkbookPpParentReplySlip: "例如：作業冊 p.12–13／家長通告回條",
    selectStudentsWithMissingWork: "選擇欠交學生",
    clearAll: "清除全部",
    studentSelectionMethod: "學生選擇方式",
    unseated_ae6ad: "未編座位",
    missingWorkForThisDate: "當日欠交記錄",
    addAnotherTask: "＋ 新增另一項",
    missing_224ea: "位欠交",
    deleteRecord: "刪除{{value}}{{value1}}記錄",
    noMissingWorkRecordedForThisDate: "這天尚未有欠交記錄。",
    classEventAdded: "班務事項已加入",
    couldNotSaveTheClassEvent: "班務事項未能保存。",
    representative: "科長｜{{subject}}",
    representative_53f0b: "科長｜{{subject}}｜二",
    enterAUniqueNameOfToCharacters: "請輸入 1 至 40 字、尚未存在的名稱。",
    added: "已加入{{value}}「{{name}}」",
    couldNotAddTheItem: "未能新增項目。",
    recordTodaySClassAffairs: "記下今天的班務",
    event: "事項",
    eGClassMeetingSeatChangesLunch: "例如：班會、座位調動、午膳提醒",
    addPeopleOrActionsNeedingFollowUp: "補充需要跟進的人或事",
    addClassEvent: "加入班務事項",
    classAffairsLog: "班務記事簿",
    noRecordsYet: "暫無記錄",
    subjectRepresentativesAndClassRoles: "學生職務",
    subjectRepresentatives: "科長",
    representative_f26c6: "科長",
    representative_8621e: "{{subject}}科長（一）",
    notAssigned: "尚未安排",
    secondRepresentative: "第二位科長",
    representative_a40c4: "{{subject}}科長（二）",
    addCustomSubject: "新增自訂科目",
    addRepresentative: "加入科長",
    classDuties: "班級服務",
    otherDuties: "其他職務",
    exportDutiesPdf: "匯出 PDF",
    addCustomClassRole: "新增自訂職務",
    addRole: "加入職務",
    quizCodeCreated: "測驗碼 {{code}} 已建立",
    couldNotCreateTheQuizTryAgain: "未能建立測驗，請稍後再試。",
    questionBankAndQuizTabs: "題庫小測分頁",
    startQuiz: "開始測驗",
    quizRecords: "測驗紀錄",
    studentHistory: "學生歷程",
    chooseQuestionBank: "選擇題庫",
    inProgress: "進行中",
    returnToOpenQuiz: "返回未結束的測驗",
    submitted_61549: "人已提交",
    customQuestionBank: "自訂題庫",
    questions: "題 ·",
    questions_39ec5: "題",
    noQuestionBanksInThisClassYet: "這個班別還沒有題庫",
    classQuiz: "課堂小測",
    backToQuestionBank: "← 返回題庫",
    timeAllowed: "作答時間",
    minutes: "2 分鐘",
    minutes_93fd4: "5 分鐘",
    minutes_5125d: "8 分鐘",
    minutes_15ebc: "10 分鐘",
    minutes_fc4d4: "15 分鐘",
    openQuizAndGenerateQRCode: "開啟測驗及產生 QR Code",
    productPreviewSimulatedSession: "產品預覽 · 模擬場次",
    studentsScanToBegin: "學生掃描後開始作答",
    classCode: "課堂碼",
    timePerStudent: "每位學生作答時間：",
    minutes_3d6c1: "分鐘",
    thisQRCodePreviewsTheLayoutOnly: "此 QR Code 只供檢視版面；要讓學生加入及提交，需先連接 Supabase。",
    qrCodeToJoinQuiz: "加入測驗 {{code}} 的 QR Code",
    openStudentPage: "開啟學生頁面 ↗",
    liveSubmissions: "即時提交",
    pastQuizRecords: "過去測驗紀錄",
    ended: "已結束",
    noClassroomQuizzesOpenedYet: "尚未開啟過課堂測驗。",
    studentQuizHistory: "學生測驗歷程",
    completedQuizzes: "完成測驗",
    averageScore: "平均分",
    latestSubmission: "最近提交",
    classCreated: "班別已建立",
    couldNotCreateTheClassTryAgain: "未能建立班別，請稍後再試。",
    importedStudents: "已匯入 {{length}} 位學生",
    addedToQuestionBank: "「{{title}}」已加入題庫",
    invalidJSONFormat: "JSON 格式不正確。",
    questionsGeneratedCheckAnswersAndSourcesBefore: "題目已生成，請核對答案與來源後再儲存",
    couldNotGenerateQuestions: "出題未能完成。",
    permanentlyDeletedAndRelatedData: "已永久刪除 {{name}} 及其關聯資料",
    couldNotDeleteStudentData: "未能刪除學生資料。",
    administrationScope: "管理範圍",
    classesAndStudents: "班級與學生",
    questionBankManagement: "題庫管理",
    schoolWideCalendar: "全校校曆",
    className: "班別名稱",
    eGBChinese: "例如：2B 中文",
    sharesRosterAndSeatingWith: "與「",
    label_36150: "」共用名單及座位表",
    status: "狀態",
    activate: "啟用",
    deactivate: "停用",
    generateQuestionsFromTeachingMaterials: "按課堂材料出題",
    doNotEnterStudentPersonalData: "不要輸入學生個人資料",
    materialsAreSentToAThirdParty:
      "教材會傳送到第三方 AI 供應商。請勿貼上學生姓名、健康、特殊教育需要、紀律或其他可識別資料。",
    teachingMaterials: "課堂材料",
    pasteThePassageOrNotesForQuestions: "貼上要出題的課文或筆記",
    numberOfQuestions: "題數",
    generating: "生成中…",
    generateIntoTheEditorBelow: "生成並放入下方編輯區",
    aiQuestionGenerationIsAvailableAfterConnecting: "連線正式 Supabase 後可使用 AI 出題。",
    reviewAndImportQuestionSet: "核對並匯入題組",
    questionSetJSON: "題組 JSON",
    nSchemaVersionNTitleClassQuizN: '{\n  "schemaVersion": 1,\n  "title": "課堂小測",\n  "questions": [...]\n}',
    validateAndAddToQuestionBank: "驗證並加入題庫",
    questionBank: "題庫",
    manualImport: "手動匯入",
    noQuestionSetsYetPasteJSONOn: "尚未有題組。從左方貼上 JSON 並驗證。",
    closePermanentDeletionDialog: "關閉永久刪除視窗",
    thisCannotBeUndoneTheStudentQuiz:
      "此操作不可還原。系統會刪除名單、小測答案及成績，並從出勤、欠交、課堂記錄、座位和職務中移除這位學生；備註內完全相同的姓名會改為「已刪除學生」。",
    enterStudentName: "輸入學生姓名「",
    toConfirm: "」以確認",
    deleting: "正在刪除…",
    permanentlyDeleteAllRelatedData: "永久刪除全部相關資料",
    importedSchoolWideEvents: "已匯入 {{length}} 項全校校曆事項",
    couldNotImportTheSchoolWideCalendar: "未能匯入全校校曆。",
    couldNotDeleteTheCalendarEvent: "未能刪除校曆事項。",
    deleteThisSchoolWideEventWillDisappear: "確定刪除「{{title}}」？這項全校事項會從所有班別日曆消失。",
    schoolWideEventDeleted: "全校校曆事項已刪除",
    deleteTheLatestEventsImportedFrom: "確定刪除最近從「{{value}}」匯入的 {{length}} 項事項？",
    latestSchoolWideCalendarImportDeleted: "最近匯入的一批全校校曆已刪除",
    sharedSchoolWideEvents: "全校共用事項",
    deleteLatestImport: "刪除最近匯入",
    importCalendar: "匯入校曆",
    schoolCalendarSummary: "全校校曆摘要",
    schoolWideEvents: "全校事項",
    importedFiles: "匯入檔案",
    eventsFromToday: "今日起事項",
    importedSchoolCalendar: "已匯入的全校校曆",
    to: "至 {{value}}",
    source: "來源：{{sourceName}}",
    delete_f46eb: "刪除 {{title}}",
    noSchoolWideCalendarImportedYet: "尚未匯入全校校曆",
    importFirstCalendar: "匯入第一份校曆",
    rows_2a2b7: "行",
    columns_ad3ee: "列",
    switchView: "轉換視角",
    unseatedStudents: "未安排學生",
    selected_cca56: "已選：",
    collapse: "收起",
    expand: "展開",
    allStudentsHaveSeats: "所有學生已安排座位。",
    no_bce6e: "{{number}} 號 {{name}}{{value}}",
    placeHere: "放到這裏",
    aisleBetweenColumnsAnd: "{{value}}第 {{value1}} 與 {{value2}} 列之間的走廊",
    aisleBetweenRowsAnd: "{{value}}第 {{value1}} 與 {{value2}} 行之間的走廊",
    publicHoliday: "公眾假期",
    schoolHoliday: "學校假期",
    specialSchoolDay: "特別上課日",
    specialDate: "特別日子",
    schoolExam: "校曆考試",
    studentActivityDay: "學生活動日",
    reminder: "提醒",
    schoolCalendar: "校曆",
    calendarEventUpdated: "日曆事項已更新",
    calendarEventAdded: "日曆事項已加入",
    couldNotSaveTheCalendarEvent: "未能儲存日曆事項。",
    calendarEventDeleted: "日曆事項已刪除",
    couldNotDeleteTheCalendarEvent_d1188: "未能刪除日曆事項。",
    previousMonth: "上一個月",
    nextMonth: "下一個月",
    today: "今天",
    filterCalendarEvents: "篩選日曆事項",
    newEvent: "＋ 新增事項",
    calendarColourLegend: "月曆顏色圖例",
    addEvent: "{{date}}{{value}}，新增事項",
    editEvent: "編輯事項",
    newEvent_4b257: "新增事項",
    saveEvent: "保存事項",
    view: "查看 {{value}}：{{title}}{{value2}}",
    notes: "備註：",
    to_1fe2b: " 至 {{value}}",
    schoolWide_0628a: "全校共用",
    noAdditionalNotes: "沒有額外備註。",
    source_dd8a9: "來源：",
    edit: "編輯",
    type: "類型",
    bringInAIGeneratedQuestions: "把 AI 生成的題目帶進來",
    pasteJSONContainingTitleQuestionsFourOptions:
      "請貼上包含 title、questions、四個 options、correctIndex 及 explanation 的 JSON。儲存前會逐題驗證。",
    classQuestionBank: "本班題庫",
    startMinuteQuiz: "開始 10 分鐘測驗",
    studentQuizCode: "學生測驗碼",
    submitted_61215: "已提交",
    responses: "份",
    previewDataJson: "{{value}}-預覽資料.json",
    fullExportJson: "{{value}}-{{value1}}-完整匯出.json",
    dataFileDownloadStarted: "已開始下載資料檔案",
    exportFailed: "匯出失敗：{{message}}",
    exportFailedTryAgain: "匯出失敗，請再試一次",
    previewModeDoesNotCreateOrDelete: "預覽模式不會建立或刪除雲端資料",
    theWorkspaceBecomesReadOnlyImmediatelyAnd: "工作空間將立即轉為唯讀，並在30日後刪除。確定繼續？",
    readOnlyDataRetainedUntil: "已轉為唯讀，資料保留至 {{value}}",
    demoData: "Demo 資料",
    trial: "試",
    dayFullTrial: "7 日完整試用",
    allNonAIFeaturesAreAvailable: "所有非 AI 功能已開放。",
    aboutDaysLeftNonAIFeaturesAre: "尚餘約 {{trialDays}} 日。試用期內不限制非 AI 功能。",
    teacherAccount: "教師帳戶",
    previewAccount: "預覽帳戶",
    dataSpace: "資料空間",
    retainedAfterCancellation: "取消後保留",
    daysReadOnly: "日唯讀",
    thePaymentPageOpensAfterStripeIs: "正式連接 Stripe 後會開啟付款頁",
    managePaymentsAndSubscription: "管理付款與訂閱",
    chooseMonthlyPlan: "選擇月費方案",
    youControlYourData: "資料由你掌握",
    fullDataExport: "完整資料匯出",
    exportNow: "立即匯出",
    deleteWorkspace: "刪除工作空間",
    readOnlyImmediatelyRetainedForExportFor: "立即轉為唯讀；預設保留30日供匯出，然後永久刪除。",
    requestDeletion: "要求刪除",
  },
} as const;
